import { LazyWithSuspense } from '../LazyWithSuspense';

// Home Pages - dynamic imports
const MyProjectsPageLazy = LazyWithSuspense(() => import('src/views/home/MyProjectsPage/MyProjectsPage')
  .then((module) => ({ default: module.MyProjectsPage })));

const OrgSettingsPageV2Lazy = LazyWithSuspense(() => import('src/views/home/Organization/General/v2')
  .then((module) => ({ default: module.OrgSettingsPageV2 })));

const OrgUsersPageLazy = LazyWithSuspense(() => import('src/views/home/Organization/Users/OrgUsersPage')
  .then((module) => ({ default: module.OrgUsersPage })));

const OrgBillingPageLazy = LazyWithSuspense(() => import('src/views/home/Organization/Billing/OrgBillingPage')
  .then((module) => ({ default: module.OrgBillingPage })));

// Onboarding Pages - dynamic imports
const CreateOrgPageLazy = LazyWithSuspense(() => import('src/views/onboarding/CreateOrgPage/CreateOrgPage')
  .then((module) => ({ default: module.CreateOrgPage })));

const CreateProjectPageLazy = LazyWithSuspense(() => import('src/views/onboarding/CreateProjectPage/CreateProjectPage')
  .then((module) => ({ default: module.CreateProjectPage })));

const ClaimDomainPageLazy = LazyWithSuspense(() => import('src/views/onboarding/ClaimDomainPage/ClaimDomainPage')
  .then((module) => ({ default: module.ClaimDomainPage })));

export {
  CreateOrgPageLazy,
  CreateProjectPageLazy,
  ClaimDomainPageLazy,
  MyProjectsPageLazy,
  OrgSettingsPageV2Lazy,
  OrgUsersPageLazy,
  OrgBillingPageLazy,
};
